import {environment} from "../../environments/environment";

export class UrlBuilder {
  private static target: string = environment.target;
  private static currentClient: string = "xx0000";
  private static modbusStatusUrl: string = "";
  private static modbusDescriptionUrl: string = "";
  private static queueUrl: string = "";
  private static mappedServoUrl: string = "";
  private static measurementDescriptionUrl: string = "";
  private static measurementDataUrl: string = "";
  private static informationUrl: string = "";
  private static frequencyUrl: string = "";
  private static dmesgLogUrl: string = "";
  private static digitalOutStatusUrl: string = "";
  private static digitalOutDescriptionUrl: string = "";
  private static digitalInDescriptionUrl: string = "";
  private static digitalInStatusUrl: string = "";
  private static counterUrl: string = "";
  private static climateLogUrl: string = "";
  private static analyserUrl: string = "";
  private static analogOutDescriptionUrl: string = "";
  private static analogOutStatusUrl: string = "";
  private static analogInRawValueUrl: string = "";

  private static aiCalibrationChannelUrl: string = "";
  private static aiCalibrationStatusUrl: string = "";
  private static connectionBaseUrl: string = "";
  private static connectionTokenUrl: string = "";
  private static climateListUrl: string = "";
  private static wifiMenuDataUrl: string = "";
  private static departmentUrl: string = "";
  private static uiDataUrl: string = "";
  private static uiComplexDevicesUrl: string = "";
  private static fastLinkInformationUrl: string = "";
  private static valveDosageDataUrl: string = "";

  private static idToken: string = "-no-token-set-";

  constructor() {
    if(environment.production) {
      UrlBuilder.target =  "https://" + environment.target;
     } else {
      UrlBuilder.target =  "https://" + environment.target;
    }

    var suffix = "/api/server.php?id=" + UrlBuilder.currentClient + "&url=/V0/";

    UrlBuilder.modbusStatusUrl          = UrlBuilder.target + suffix + "modbus";
    UrlBuilder.queueUrl                 = UrlBuilder.target + suffix + "queue";
    UrlBuilder.modbusStatusUrl          = UrlBuilder.target + suffix + "modbus";
    UrlBuilder.modbusDescriptionUrl     = UrlBuilder.target + suffix + "modbus";
    UrlBuilder.mappedServoUrl           = UrlBuilder.target + suffix + "servo";
    UrlBuilder.measurementDescriptionUrl= UrlBuilder.target + suffix + "measurement/list";
    UrlBuilder.measurementDataUrl       = UrlBuilder.target + suffix + "measurement/data";
    UrlBuilder.informationUrl           = UrlBuilder.target + suffix + "info";
    UrlBuilder.frequencyUrl             = UrlBuilder.target + suffix + "frequency";
    UrlBuilder.dmesgLogUrl              = UrlBuilder.target + suffix + "log_dmesg";
    UrlBuilder.digitalOutStatusUrl      = UrlBuilder.target + suffix + "digitalout";
    UrlBuilder.digitalOutDescriptionUrl = UrlBuilder.target + suffix + "digitalout/list";
    UrlBuilder.digitalInDescriptionUrl  = UrlBuilder.target + suffix + "digitalin/list";
    UrlBuilder.digitalInStatusUrl       = UrlBuilder.target + suffix + "digitalin";
    UrlBuilder.counterUrl               = UrlBuilder.target + suffix + "counter";
    UrlBuilder.climateLogUrl            = UrlBuilder.target + suffix + "log_climate";
    UrlBuilder.analyserUrl              = UrlBuilder.target + suffix + "key";
    UrlBuilder.analogOutDescriptionUrl  = UrlBuilder.target + suffix + "analogout/list";
    UrlBuilder.analogOutStatusUrl       = UrlBuilder.target + suffix + "analogout";
    UrlBuilder.analogInRawValueUrl      = UrlBuilder.target + suffix + "analogin/raw";
    UrlBuilder.aiCalibrationChannelUrl  = UrlBuilder.target + suffix + "adc/channel";
    UrlBuilder.aiCalibrationStatusUrl   = UrlBuilder.target + suffix + "adc/current";
    UrlBuilder.connectionBaseUrl        = UrlBuilder.target + suffix + "connection";
    UrlBuilder.connectionTokenUrl       = UrlBuilder.target + suffix + "connection/token";
    UrlBuilder.climateListUrl           = UrlBuilder.target + suffix + "climatelist";
    UrlBuilder.wifiMenuDataUrl          = UrlBuilder.target + suffix + "menudata";
    UrlBuilder.departmentUrl            = UrlBuilder.target + suffix + "department";
    UrlBuilder.uiDataUrl                = UrlBuilder.target + suffix + "ui";
    UrlBuilder.uiComplexDevicesUrl      = UrlBuilder.target + suffix + "complexdevice";
    UrlBuilder.fastLinkInformationUrl   = UrlBuilder.target + suffix + "fastlinkmonitor";
    UrlBuilder.valveDosageDataUrl       = UrlBuilder.target + suffix + "valvedosage";
  }


  GetTarget():                      string { return UrlBuilder.target;  }
  GetConnectionBaseUrl():           string { return UrlBuilder.connectionBaseUrl;  }
  GetConnectionTokenUrl():          string { return UrlBuilder.connectionTokenUrl;  }
  GetQueueUrl():                    string { return UrlBuilder.queueUrl;  }
  GetMappedServoUrl():              string { return UrlBuilder.mappedServoUrl;  }
  GetModbusStatusUrl():             string { return UrlBuilder.modbusStatusUrl;  }
  GetModbusDescriptionUrl():        string { return UrlBuilder.modbusDescriptionUrl;  }
  GetMeasurementDescriptionUrl():   string { return UrlBuilder.measurementDescriptionUrl;  }
  GetMeasurementDataUrl():          string { return UrlBuilder.measurementDataUrl;  }
  GetFrequencyUrl():                string { return UrlBuilder.frequencyUrl;  }
  GetDmesgLogUrl():                 string { return UrlBuilder.dmesgLogUrl;  }
  GetDigitalOutStatusUrl():         string { return UrlBuilder.digitalOutStatusUrl;  }
  GetDigitalOutDescriptionUrl():    string { return UrlBuilder.digitalOutDescriptionUrl;  }
  GetDigitalInStatusUrl():          string { return UrlBuilder.digitalInStatusUrl;  }
  GetDigitalInDescriptionUrl():     string { return UrlBuilder.digitalInDescriptionUrl;  }
  GetCounterUrl():                  string { return UrlBuilder.counterUrl;  }
  GetClimateLogUrl() :              string { return UrlBuilder.climateLogUrl;  }
  GetAnalyserUrl():                 string { return UrlBuilder.analyserUrl;  }
  GetAnalogOutDescriptionUrl():     string { return UrlBuilder.analogOutDescriptionUrl;  }
  GetAnalogOutStatusUrl():          string { return UrlBuilder.analogOutStatusUrl;  }
  GetAnalogInRawValueUrl():         string { return UrlBuilder.analogInRawValueUrl;  }

  GetAiCalibrationChannelUrl():     string { return UrlBuilder.aiCalibrationChannelUrl;  }
  GetAiCalibrationStatusUrl():      string { return UrlBuilder.aiCalibrationStatusUrl;  }
  GetCurrentClient():               string { return UrlBuilder.currentClient; }
  GetInformationUrl():              string { return UrlBuilder.informationUrl; }
  GetClimateListUrl():              string { return UrlBuilder.climateListUrl; }
  GetWifiMenuDataUrl():             string { return UrlBuilder.wifiMenuDataUrl; }
  GetDepartmentUrl():               string { return UrlBuilder.departmentUrl; }
  GetUiDataUrl():                   string { return UrlBuilder.uiDataUrl; }
  GetComplexDevicesUrl():           string { return UrlBuilder.uiComplexDevicesUrl; }
  GetFastLinkInformationUrl():      string { return UrlBuilder.fastLinkInformationUrl; }
  GetValveDosageDataUrl():          string { return UrlBuilder.valveDosageDataUrl; }

  SetCurrentClient(newClient: string):void { UrlBuilder.currentClient = newClient;
    console.log('URL UPDATE SELECTED CLIENT: ' + UrlBuilder.currentClient);
  }

  SetIdToken(newToken: string): void
  {
    console.log('Token is set');
    UrlBuilder.idToken = newToken;
  }

  GetToken(): string {
    return UrlBuilder.idToken;
  }

}
